module.exports = __webpack_public_path__ + "img/62_10.08e0dee5.png";